import { useEffect, useRef, useState } from 'react';
import { SortKey, SortOrder, sortValues } from '../../../catalog';
import { ViewMode } from '../catalog-wrapper';

interface SortRowProps {
    sortBy: SortKey;
    sortOrder: SortOrder;
    onSortChange: (key: SortKey) => void;
    viewMode: ViewMode;
    setViewMode: (mode: ViewMode) => void;
}

function SortRow({ sortBy, sortOrder, onSortChange, viewMode, setViewMode }: SortRowProps) {
    const [showSortDropdown, setShowSortDropdown] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const onSort = (key: SortKey) => {
        onSortChange(key);
        setShowSortDropdown(false);
    };

    useEffect(() => {
        if (showSortDropdown) {
            const callback = (e: MouseEvent) => {
                if (!dropdownRef.current?.contains(e.target as Node)) {
                    setShowSortDropdown(false);
                }
            };
            window.addEventListener('click', callback);
            return () => window.removeEventListener('click', callback);
        }
    }, [showSortDropdown]);
    return (
        <>
            <div
                className={'select-box selectable' + (showSortDropdown ? ' active' : '')}
                ref={dropdownRef}
                onClick={() => setShowSortDropdown(!showSortDropdown)}
            >
                <span className="select-box__cont">{sortBy && sortValues[sortBy]}</span>
                <ul className="select-box__dropdown" style={{ display: showSortDropdown ? 'block' : 'none' }}>
                    {Object.entries(sortValues).map(([key, name]) => (
                        <li key={key}>
                            <span key={key} className="checkbox__txt" onClick={() => onSort(key as SortKey)}>
                                {name}
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
            <div style={{ display: 'flex' }}>
                <span
                    className={'catalog-nav__btn' + (viewMode === ViewMode.List ? ' active' : '')}
                    onClick={() => setViewMode(ViewMode.List)}
                >
                    <svg className="icon" xmlns="http://www.w3.org/2000/svg" width="15" height="15">
                        <path
                            d="M0 0h3v3H0V0zm0 6h3v3H0V6zm0 6h3v3H0v-3zM6 0h9v3H6V0zm0 6h9v3H6V6zm0 6h9v3H6v-3z"
                            fill="#2d4345"
                            fillRule="evenodd"
                        />
                    </svg>
                </span>
                <span
                    className={'catalog-nav__btn' + (viewMode === ViewMode.Tile ? ' active' : '')}
                    onClick={() => setViewMode(ViewMode.Tile)}
                >
                    <svg className="icon" xmlns="http://www.w3.org/2000/svg" width="15" height="15">
                        <path
                            d="M0 0h3v3H0V0zm0 6h3v3H0V6zm0 6h3v3H0v-3zM6 0h3v3H6V0zm0 6h3v3H6V6zm0 6h3v3H6v-3zm6-12h3v3h-3V0zm0 6h3v3h-3V6zm0 6h3v3h-3v-3z"
                            fill="#2d4345"
                            fillRule="evenodd"
                        />
                    </svg>
                </span>
            </div>
        </>
    );
}

export default SortRow;
